import React, { memo, useCallback, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { IPageEnd } from 'app/store/nodes/card/interfaces';
import * as lastPageActions from 'app/store/nodes/lastPage/actions';
import Analytics from 'app/lib/Analytics/Analytics';
import styles from './Holiday.module.css';

interface IHoliday {
  data?: IPageEnd,
}

const Holiday: React.FC<IHoliday> = memo((props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(lastPageActions.showHoliday());
  }, [dispatch]);

  const handleSkipBirthday = useCallback(() => {
    Analytics.track().tappedSkipHolidayReminder();
    dispatch(lastPageActions.shiftStep());
  }, [dispatch]);

  const handleRemindHoliday = useCallback(() => {
    dispatch(lastPageActions.remindHoliday());
  }, [dispatch]);

  return (
    <div className={styles.steps}>
      <div className={styles.header}>
        Send More Smiles
      </div>
      <div className={styles.description}>
        Would you like to receive
        <br />
        text message reminders for
        <br />
        upcoming holidays?
      </div>
      <div className={styles.buttons}>
        <button className={styles.next} type="button" onClick={handleSkipBirthday}>
          <span>skip</span>
        </button>
        <button className={styles.remindMe} type="button" onClick={handleRemindHoliday}>
          remind me
        </button>
      </div>
    </div>
  );
});

export default Holiday;
